module.exports = __webpack_public_path__ + "media/images/photo/community_ipad-30bbca13c010057bbff7a61727231f68.png";